import request  from './axiosFun';
// 根据用户id，项目id 查询用户开通项目
 export function pageMatterInfo(query) {
   var url = ''
   if (process.env.NODE_ENV === "development") {
     url = '/est/livestock/matterinfo/pageMatterInfo'
   }else {
     url = '/livestock/matterinfo/pageMatterInfo'
   }
   return request({
     url: url,
    method: 'post',
    data:query
  })
}
// 出入库列表
export function pageMatterRecord(query) {
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterrecord/pageMatterRecord'
  }else {
    url = '/livestock/matterrecord/pageMatterRecord'
  }
  return request({
    url: url,

    method: 'post',
    data:query
  })
}

//出入库删除
export function delMatterRecord(query){
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterrecord/delMatterRecord/'+query
  }else {
    url = '/livestock/matterrecord/delMatterRecord/'+query
  }
  return request({
    url: url,

    method: 'post',
  })
}


// 类型
export function countMatterInfoByC(query) {
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/mattercategory/countMatterInfoByCategory'
  }else {
    url = '/livestock/mattercategory/countMatterInfoByCategory'
  }
  return request({
    url: url,
    method: 'post',
    data:query
  })
}
// 待领取列表
export function pageList(query) {
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterreceiveordistribute/page'
  }else {
    url = '/livestock/matterreceiveordistribute/page'
  }
  return request({
    url: url,
    method: 'post',
    data:query
  })
}
// 领取物料


export function materialCollection(query) {
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterreceiveordistribute/materialCollection'
  }else {
    url = '/livestock/matterreceiveordistribute/materialCollection'
  }
  return request({
    url: url,
    method: 'post',
    data:query
  })
}



//下发人
export function getUserListByAreasId(query){
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/pasture/userInfo/getUserListByAreasId'
  }else {
    url = '/pasture/userInfo/getUserListByAreasId'
  }
  return request({
    url: url,
    method: 'post',
    data:query
  })
}
// 入库
export function saveMatterRecord(query){
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterinfo/saveMatterInfo'
  }else {
    url = '/livestock/matterinfo/saveMatterInfo'
  }
  return request({
    url: url,

    method: 'post',
    data:query
  })
}
// 单位字典

export function findDictList(query){
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/pasture/sys/findDictList'
  }else {
    url = '/pasture/sys/findDictList'
  }
  return request({
    url: url,
    method: 'post',
    data:query
  })
}
// 物料下发

export function materialDelivery(query){
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterreceiveordistribute/materialDelivery'
  }else {
    url = '/livestock/matterreceiveordistribute/materialDelivery'
  }
  return request({
    url: url,
    method: 'post',
    data:query
  })
}
// 删除物料
export function delMatterInfo(query){
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterinfo/delMatterInfo/' + query
  }else {
    url = '/livestock/matterinfo/delMatterInfo/' + query
  }
  return request({
    url: url,
    method: 'post',
  })
}

// 下发列表

export function pageForOut(data){
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/livestock/matterrecord/pageMatterRecordForOut'
  }else {
    url = '/livestock/matterrecord/pageMatterRecordForOut'
  }
  return request({
    url: url,
    method: 'post',
    data
  })
}
// 人员列表
export function getUserList(query) {
  var url = ''
  if (process.env.NODE_ENV === "development") {
    url = '/est/pasture/userInfo/getUserListByAreasIdWithPageInfo'
  }else {
    url = '/pasture/userInfo/getUserListByAreasIdWithPageInfo'
  }
  return request({
    url: url,
    method: 'post',
    data:query

  })
}



// WEBPACK FOOTER //
// ./src/api/material.js